import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SvgIcon } from '../SvgIcon';
import { InnerContainer } from './TabLabelWithIcon.styled';
/** Used when {@link Tab} must have two icons on both sides, primary icon to the left and a badge to the right, for example. */
const TabLabelWithIcon = ({ icon, label }) => {
    return (_jsxs(InnerContainer, { children: [_jsx(SvgIcon, { icon: icon }), label] }));
};
export { TabLabelWithIcon };
